// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var LightBulb = React.forwardRef(function LightBulb(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "LightBulb" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M15.8227 12.4409C16.8782 11.1317 18 9.74019 18 7.88789C18 4.24128 14.8781 2 11.9971 2C9.11808 2 6 4.23932 6 7.88789C6 9.74019 7.12185 11.1317 8.17731 12.4409C9.11484 13.6039 10 15.7018 10 17H12H14C14 15.7018 14.8852 13.6039 15.8227 12.4409Z", fill: "currentColor" }),
            React.createElement("path", { d: "M14 18H12H10V19H14V18Z", fill: "currentColor" }),
            React.createElement("path", { d: "M10 20H14V21C14 21 13 22 12 22C11 22 10 21 10 21V20Z", fill: "currentColor" }))));
});
LightBulb.displayName = 'LightBulb';
export default LightBulb;
//# sourceMappingURL=LightBulb.js.map